module.exports = __webpack_public_path__ + "static/media/Voter ID back.f08a4f71.jpg";